// extracted by mini-css-extract-plugin
export default {"title":"DeleteConfirmation_title__teuGD","icon":"DeleteConfirmation_icon__zbQ+h","content":"DeleteConfirmation_content__TgKek"};